import { getCookie } from './cookies';

export const getPartnerTrackingProperties = () => {
  const partner = getCookie('partner');
  const partnerDisplayName = getCookie('partner_display_name');

  return {
    ...(partner && { partner_code: partner }),
    ...(partnerDisplayName && { partner_name: partnerDisplayName })
  };
};
